import uuid from "react-uuid";
import { setPrepaidId } from "redux/action";
import { qrPrepaidInit } from "utils/qrPrepaidService";

// qr-prepaid trả thông tin tài khoản TGS qua 3 field: customer-number,
// customer-name, customer-phone. Quy về dạng infoUserTgs mà các màn đang đọc
// (customer-number, full-name, cellphone). Trả về null nếu không có tài khoản.
export const mapPrepaidCustomer = (data) => {
  const customerNumber = data?.["customer-number"];
  if (!customerNumber) return null;
  return {
    "customer-number": customerNumber,
    "full-name": data?.["customer-name"] || "",
    cellphone: data?.["customer-phone"] || "",
  };
};

// Mỗi lần quét QR là một lần tải trang mới nên cờ này được reset. Chỉ lần gọi
// đầu tiên sau khi tải trang trả về true: màn quét QR có thể mount lại (vd khách
// bấm Back) nhưng không tính là một lượt quét mới.
let isQrScanConsumed = false;
export const consumeNewQrScan = () => {
  if (isQrScanConsumed) return false;
  isQrScanConsumed = true;
  return true;
};

// Đăng xuất TGS ở trả trước: tài khoản gắn với prepaid-id trên BE nên xoá local
// là chưa đủ (màn thanh toán sẽ lấy lại từ qr-prepaid/detail). Lấy prepaid-id
// mới để tách khỏi tài khoản cũ.
export const reinitPrepaidSession = async ({
  homeBrand,
  isLanguageEnglish,
  dispatch,
}) => {
  const tableCode = homeBrand?.["table-code"] || homeBrand?.table?.code;
  const menuCode = homeBrand?.["category-code"];
  if (!tableCode || !menuCode) return null;

  let deviceId = localStorage.getItem("prepaidDeviceId");
  if (!deviceId) {
    deviceId = uuid();
    localStorage.setItem("prepaidDeviceId", deviceId);
  }
  const response = await qrPrepaidInit({
    menuCode,
    deviceId,
    tableCode,
    language: isLanguageEnglish ? "en" : "vi",
  });
  const newPrepaidId = response?.value?.data?.["prepaid-id"];
  if (response?.value?.code === "200" && newPrepaidId) {
    dispatch(setPrepaidId(newPrepaidId));
    sessionStorage.setItem("qrPrepaidId", newPrepaidId);
    return newPrepaidId;
  }
  return null;
};
